import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ReleaseCalendarProduct } from "../../types/release-calendar-types";
import { UtilityService } from "../../../../../core/services/utility.service";

@Component({
  selector: 'app-release-calendar-product',
  standalone: true,
  imports: [],
  templateUrl: './release-calendar-product.component.html',
  styleUrl: './release-calendar-product.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReleaseCalendarProductComponent {
  releaseCalendarProduct = input.required<ReleaseCalendarProduct>();
  hidden = input.required<boolean>();

  private utilityService: UtilityService = inject(UtilityService);

  public formatBudgetValue(value: number): string {
    return this.utilityService.formatBudgetValue({ value });
  }
}
